exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".more-options-animation-enter-active[data-v-002f0a03],.more-options-animation-leave-active[data-v-002f0a03]{transition:opacity .15s cubic-bezier(1,.5,.8,1)}.more-options-animation-enter[data-v-002f0a03],.more-options-animation-leave-to[data-v-002f0a03]{opacity:0}", ""]);

// exports
